<div class="body">
    <div class="appWrapper screen">
        <div class="appHeader">
            <span class="badge fs-14 rounded-pill p-2 bg-black back_button pointer" (click)="goBack()">
                <span class="text-theme-green align-middle"
                    style="color:#ffffff !important; padding-right: 11px;line-height:20px;padding-left: 5px;">
                   <img src="./assets/images/back_left_arrow.png" width="16" height="7" alt="arrow"
                      class="img-fluid" /> Back
                  </span>
            </span>
            <div class="d-flex align-items-center justify-content-between mb-4">
                <div class="d-flex gap-3">
                    <h5 class="fs-18 lh-1 fw-bold mb-0 text-black">
                        <span>Dealer Locator</span>
                    </h5>
                </div>
            </div>
            <div class="card bg-transparent border-0 mb-4">
                <form action="#" method="post">
                    <div class="input-group rounded-pill bg-white py-1 px-2 search_text">
                        <span class="input-group-text bg-transparent border-0 pe-1" id="basic-addon1"><img
                                src="./assets/images/search.svg" alt="search" class="img-fluid" /></span>
                        <input type="text" class="form-control bg-transparent border-0 ps-1" style="padding-left: 0px;"
                            placeholder="Search Store Name" aria-label="Search Store Name"
                            aria-describedby="basic-addon1" name="search-text" id="search-text" [(ngModel)]="searchText"
                            (keyup)="onSearchKeyUp()">
                    </div>
                </form>
            </div>
            <div class="tabs">
                <ul class="nav nav-pills justify-content-center" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation" *ngFor="let data of tab1">
                        <button class="nav-link normal_font" [ngClass]="{'selected_button': selectedTab===data}"
                            id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pill-home" type="button"
                            role="tab" aria-controls="pills-home" aria-selected="false"
                            (click)="changeTab(data)">{{data}}</button>
                    </li>
                </ul>
            </div>
        </div>
        <div class="appbody">
            <div class="appbody-wrap position-relative">
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                        aria-labelledby="pills-home-tab" tabindex="0">
                        <div class="main-card" *ngIf="dealersdata.length;else elseproperty">
                            <div class="card-list" *ngFor="let item of dealersdata">
                                <div class="card border-0 card_border_radius">
                                    <div class="card-body ">
                                        <div class="row">
                                            <div class="col-8 pointer" (click)="redirecToUrl('details',item)">
                                                <h5 class="h5 mb-2 fw-bold text-theme-green name_text">
                                                    {{item.DEALER_NAME}}</h5>
                                                <div
                                                    class=" d-flex align-items-center fw-semibold fs-14 text-dark mb-3 normal_font">
                                                    <div class="flex-col">{{item.FILLER_1}}
                                                    </div>
                                                </div>
                                                <div class="d-flex flex-column fs-14">
                                                    <div class="d-flex gap-2 mb-2">
                                                        <div class="flex-col flex-shrink-0"><img
                                                                src="./assets/images/call.svg" alt="call"
                                                                class="img-fluid" /></div>
                                                        <div class="flex-col normal_font_variant ml-2">{{item.MOBILE}}
                                                        </div>
                                                    </div>
                                                    <div class="d-flex gap-2 mb-2">
                                                        <div class="flex-col flex-shrink-0"><img
                                                                src="./assets/images/map-pin.svg" alt="map-pin"
                                                                class="img-fluid" /></div>
                                                        <div class="flex-col normal_font_variant ml-2">{{item.ADDRESS}}
                                                        </div>
                                                    </div>
                                                    <div class="d-flex gap-2">
                                                        <div class="flex-col flex-shrink-0"><img
                                                                src="./assets/images/clock.svg" alt="map-pin"
                                                                class="img-fluid" /></div>
                                                        <div class="flex-col normal_font_variant ml-2">{{item.TIMINGS}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="d-flex  position-absolute top-0 end-0  ">
                                                    <!-- href="tel:8709098098" -->
                                                    <!-- <span class="pointer"><img src="./assets/images/call-circle.svg"
                                                            alt="call" class="img-fluid " /></span> -->
                                                    <span (click)="getDirection(item)" class="mapPin pointer mapin"><img
                                                            src="./assets/images/map-pin-circle.svg" alt="map-pin"
                                                            class="img-fluid pl-2" /></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #elseproperty>
                            <div class="">
                                <div class="card-list">
                                    <div class="card border-0 card_border_radius">
                                        <div class="cardbody">
                                            Sorry no data found..
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
                <!-- <a (click)="redirecToUrl('store',[])" class="position-absolute bottom-0 end-0 mb-4 mr-4 z-2"
                    style="margin-left: 250px;bottom: 0;">
                    <img src="./assets/images/map-pin-toggle.svg" alt="map-pin" class="img-fluid"
                        style="cursor: pointer;" /></a> -->
            </div>
        </div>

        
    </div>
</div>
<loader *ngIf="loader"></loader>